module.exports = __webpack_public_path__ + "static/media/sixteen.d3ff4ca3.jpg";